module.exports = __webpack_public_path__ + "img/LYKTA.af914e63.jpg";